import React from "react";
import { parseOrdering, buildOrdering } from "../utils/filterParams";
import ClientRow from "./ClientRow";

// Only these 4 columns have a backend `ordering` value to sort by — plain
// <table>, not TableContainer/@tanstack, same reasoning as
// Contract/List/components/ContractsTable.js (manual server-side ordering,
// not a client-side re-sort of the current page).
const COLUMNS = [
  { key: "name", label: "Client", sortable: true, defaultDir: "asc" },
  { key: "contact", label: "Contact", sortable: false },
  { key: "contracts", label: "Contracts", sortable: true, defaultDir: "desc" },
  { key: "next_payment", label: "Next payment", sortable: true, defaultDir: "asc" },
  { key: "value", label: "Value", sortable: true, defaultDir: "desc", align: "right" },
];

const ClientsTable = ({ clients, ordering, onSortChange, onRowClick, canDelete, onDeleteRequest, formatCurrency }) => {
  const { field: activeField, dir: activeDir } = parseOrdering(ordering);

  const handleHeaderClick = (col) => {
    if (!col.sortable) return;
    const dir = activeField === col.key ? (activeDir === "asc" ? "desc" : "asc") : col.defaultDir;
    onSortChange(buildOrdering(col.key, dir));
  };

  return (
    <div className="table-responsive">
      <table className="table align-middle table-nowrap mb-0">
        <thead className="table-light text-muted">
          <tr>
            {COLUMNS.map((col) => (
              <th
                key={col.key}
                onClick={() => handleHeaderClick(col)}
                style={{
                  cursor: col.sortable ? "pointer" : "default",
                  textAlign: col.align || "left",
                  fontSize: 11,
                  fontWeight: 650,
                  letterSpacing: "0.6px",
                  textTransform: "uppercase",
                  whiteSpace: "nowrap",
                }}
              >
                {col.label}
                {col.sortable && activeField === col.key ? (activeDir === "asc" ? " ↑" : " ↓") : ""}
              </th>
            ))}
            <th style={{ width: 70 }}></th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <ClientRow
              key={client.id}
              client={client}
              onRowClick={onRowClick}
              canDelete={canDelete}
              onDeleteRequest={onDeleteRequest}
              formatCurrency={formatCurrency}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ClientsTable;
